"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
exports.routes = {
    FORGOT: '/forgot',
    FORGOT_SUCCESS: '/forgot-success',
    CONFIRM: '/confirm',
    RESET: '/reset-password',
    RESET_SUCCESS: '/reset-password-success',
    HOME: '/',
    LOGIN: '/login',
    REGISTER: '/register',
    ERROR: '/auth-error',
    LOGOUT: '/logout',
    ACCEPT_INVITATION: '/accept-invitation',
    ACCEPT_INVITATION_SUCCESS: '/accept-invitation-success',
};
//# sourceMappingURL=routes.js.map